import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../shared/api.service';

@Injectable({
    providedIn: 'root'
})
export class SalaryHistoryService {

    constructor(private api: ApiService) { }

    list(employeeId: number | string): Observable<any> {
        return this.api.get(`hr/employee/${employeeId}/salary-history/list`);
    }

    add(employeeId: number | string, payload: any): Observable<any> {
        return this.api.post(`hr/employee/${employeeId}/salary-history/add`, payload);
    }
}
